import React, { useEffect, useRef, useState } from "react";
import queryString from 'query-string';
import { useReactToPrint } from "react-to-print";

// reactstrap components
import { Button, Card, CardBody, Row, Col } from "reactstrap";

// services
import { showMessage } from "../../services/message.js";
import { api_GET } from "../../services/api_service.js";
import { htmlCertidao, preservaQuebras } from "../../helpers/textoCertidao.js";

// components
import LogoSistema from "../../components/LogoSistema/LogoSistema";

//Context
import { useAuth } from "../../context/auth";

/**
 * Certidão de Destinação Final (Gerador RSS).
 * O texto chega da API já com as variáveis do modelo resolvidas.
 */
export default function CertidaoDestinacaoFinalRSS({ history }) {
    const { setLoading } = useAuth();

    const [certidao, set_certidao] = useState(null);

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        copyStyles: true
    });

    const loadDados = () => {
        let urls = history.location.search;
        let params = queryString.parse(urls);

        if (params.protocolo == null || params.requerimento == null) {
            showMessage("Aviso", "Certidão não informada!", 'error', null);
            return;
        }

        setLoading(true);
        api_GET('Requerimento/GetCertidaoPorNumero/' + encodeURIComponent(params.protocolo) + '/' + encodeURIComponent(params.requerimento))
            .then(result => set_certidao(result.data))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadDados();
    }, []);

    return (
        <>
            {/* O editor grava fonte, tamanho e alinhamento inline, mas o recuo sai como
                classe ql-indent-N, que sem o CSS do Quill não renderiza aqui. */}
            <style>
                {`
                    .texto-certidao p { margin: 0; }
                    .texto-certidao .ql-indent-1 { padding-left: 3em; }
                    .texto-certidao .ql-indent-2 { padding-left: 6em; }
                    .texto-certidao .ql-indent-3 { padding-left: 9em; }
                    .texto-certidao .ql-indent-4 { padding-left: 12em; }
                `}
            </style>
            {certidao != null &&
                <div className="d-flex flex-column justify-content-center align-items-center">
                    <div className="mt-3 mb-3">
                        <Button color="success" type="button" onClick={handlePrint}>
                            <i className="fas fa-print"></i>  Imprimir
                        </Button>
                    </div>
                    <Card style={{ width: "100%", height: "29.7cm" }} innerRef={componentRef}>
                        <CardBody>
                            <div style={{ border: "1px solid black", padding: "0.5cm", height: "100%" }}>
                                <Row style={{ borderBottom: "1px solid black", alignItems: "center" }}>
                                    <Col md="3" style={{ justifyContent: "center" }}>
                                        <LogoSistema identificacaoLogo={"logotipo"} width='150' style={{ marginTop: "10px", marginBottom: "10px" }} />
                                    </Col>
                                    <Col md="6" className="text-center">
                                        <h5 style={{ marginTop: "10px", marginBottom: "5px" }}><strong>Agência Reguladora de Serviços Públicos </strong></h5>
                                        <h5 style={{ marginBottom: "10px" }}><strong>do Município de São Paulo</strong></h5>
                                    </Col>
                                    <Col md="3" className="text-right" style={{ justifyContent: "center" }}>
                                        <LogoSistema identificacaoLogo={"logoSecundario"} width='160rem' />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" className="text-center mt-2">
                                        <h3 style={{ marginBottom: "5px" }}><b>Certidão de Destinação Final</b></h3>
                                        {certidao.sigla != null &&
                                            <h5 style={{ marginBottom: "10px" }}><b>{certidao.sigla}</b></h5>
                                        }
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" className="mt-3">
                                        <div
                                            className="texto-certidao"
                                            style={{ whiteSpace: preservaQuebras(certidao.textoCertidao) ? "pre-wrap" : "normal", textAlign: "justify" }}
                                            dangerouslySetInnerHTML={htmlCertidao(certidao.textoCertidao)}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            }
        </>
    );
}
